import { useTranslation } from 'react-i18next'

// El label de cada item de navegación viene hoy de drawerStore.ts (persistido
// en localStorage con el texto en español baked in). En vez de traducir ese
// store —lo que dejaría el idioma "congelado" en la primera carga—, se
// resuelve el label acá a partir del path, que es estable e independiente
// del idioma.
const PATH_TO_KEY: Record<string, string> = {
  '/novedades': 'nav.novedades',
  '/historial': 'nav.historial',
  '/periodos': 'nav.periodos',
  '/nomina': 'nav.nomina',
  '/parametros': 'nav.parametros',
  '/empresa': 'nav.empresa',
  '/empresas': 'nav.empresas',
  '/usuarios': 'nav.usuarios',
  '/parametrosportal': 'nav.parametrosportal',
  '/gestiondecliente': 'nav.gestionCliente',
}

export const navLabelKey = (path: string): string | undefined => PATH_TO_KEY[path]

export const useNavLabel = () => {
  const { t } = useTranslation('layout')
  return (path: string, fallbackLabel: string): string => {
    const key = navLabelKey(path)
    return key ? t(key) : fallbackLabel
  }
}
